import React, { useState, useEffect } from "react";
import styles from "./UserInfo.module.scss";
import { connect } from "react-redux";
import { setFile, openMainModal, closeMainModal, sendContactNotification, openCalificationModal, getVisits } from "../../../../store/actions";
import { openSendContactNotificationModal } from "../../../../store/actions";
import { setPreviousLocation } from "../../../../store/actions";
import { ReactComponent as WebIcon } from "../../../../assets/svg/webIcon.svg";
import Tooltip from "../../../UI/ToolTip/ToolTip";
import { useActionGuard } from "../../../../hooks/useActionGuard.ts";
import useUserImage from "../../../../hooks/useUserImage";
import { fireAnalytics } from "../../../../utils/firebase";
import { MessageCircle, Star, Mail, UserRoundPen, Eye, Settings } from "lucide-react";

const UserInfo = ({
  userData,
  profileVisualizerData,
  myPerson,
  setIsEditing,
  openSendContactNotificationModal,
  openCalificationModal,
  getVisits,
  profileVisits,
  setIsSettingsOpen,
}) => {

  const data = myPerson ? userData : (profileVisualizerData || {});

  const {
    username,
    type,
    razon_social,
    name,
    last_name,
    url_site_web,
    stars,
  } = data



  const [showToolTip, setShowToolTip] = useState({
    email: { show: false, text: "Enviar correo" },
    web: { show: false, text: "Visitar sitio web" },
  });

  const { imageError, initials, profileImage } = useUserImage(data);

  useEffect(() => {
    getVisits();
  }, [getVisits]);

  const { guard } = useActionGuard();

  const handleTooltip = (tooltip) => {
    setShowToolTip((prevState) => ({
      ...prevState,
      [tooltip]: { ...prevState[tooltip], show: !prevState[tooltip].show },
    }));
  };

  let userNameInfo;
  if (type === "COMPANY") {
    userNameInfo = razon_social;
  } else if (name && last_name) {
    userNameInfo = `${name} ${last_name}`;
  }

  const formattedUrl = url_site_web ? (url_site_web.startsWith('http') ? url_site_web : `https://${url_site_web}`) : '#';

  const hasStars = typeof stars === "number" && Number.isFinite(stars);
  const formattedStars = hasStars ? (Number.isInteger(stars) ? stars.toFixed(0) : stars.toFixed(1)) : null;

  const handleMail = (email) => {
    const isGmail = email?.includes("@gmail.com");
    const mailtoLink = isGmail ? `https://mail.google.com/mail/?view=cm&fs=1&to=${email}` : `mailto:${email}`;
    window.open(mailtoLink, "_blank");
  }

  const handleSendMesssage = () => {
    openSendContactNotificationModal(data);
  }


  return (
    <div className={styles.userInfoContainer}>
      <div className={styles.header}>
        <div className={styles.avatar}>
          {!imageError && profileImage ? (
            <img
              className={styles.avatarImg}
              src={profileImage}
              alt="user"
            />
          ) : (
            <span className={styles.initials}>
              {initials || "N/A"}
            </span>
          )}
        </div>
        <div className={styles.headerContent}>
          {(userNameInfo || hasStars) && (
            <div className={styles.titleRow}>
              {userNameInfo && (
                <h2 className={styles.title}>{userNameInfo}</h2>
              )}
              {hasStars && (
                <div className={styles.rating}>
                  <Star className={styles.ratingIcon} size={16} />
                  <span className={styles.ratingValue}>{formattedStars}</span>
                </div>
              )}
            </div>
          )}
          <div className={styles.contactRow}>
            <div
              className={styles.contactChip}
              onClick={() => handleMail(username)}
              onMouseEnter={() => handleTooltip("email")}
              onMouseLeave={() => handleTooltip("email")}
            >
              <Mail size={16} />
              <span>Enviar email</span>
              {showToolTip.email.show && (
                <Tooltip text={showToolTip.email.text} fromHeaderNav />
              )}
            </div>
            {url_site_web && (
              <div
                className={styles.contactChip}
                onMouseEnter={() => handleTooltip("web")}
                onMouseLeave={() => handleTooltip("web")}
              >
                <a href={formattedUrl} target="_blank" rel="noreferrer" className={styles.contactLink}>
                  <WebIcon width={16} height={16} className={styles.contactIcon} />
                  <span>Sitio web</span>
                </a>
                {showToolTip.web.show && (
                  <Tooltip text={showToolTip.web.text} fromHeaderNav />
                )}
              </div>
            )}
          </div>
        </div>
      </div>
      <div className={styles.actions}>
        {myPerson ? (
          <div className={styles.ownerActions}>
            <div className={styles.visitsChip}>
              <Eye size={18} />
              <div className={styles.visitsCount}>
                {profileVisits.viewsCount}
                <span className={styles.visitsLabel}>visitas</span>
              </div>
            </div>
            <div className={styles.ownerButtons}>
              <button
                type="button"
                className={`${styles.actionButton} ${styles.secondaryAction}`}
                onClick={guard("edit_profile", () => setIsEditing(true))}
              >
                <UserRoundPen size={16} />
                <span>Editar perfil</span>
              </button>
              <button
                type="button"
                className={`${styles.actionButton} ${styles.iconOnly}`}
                onClick={() => setIsSettingsOpen && setIsSettingsOpen(true)}
                title="Configuración"
              >
                <Settings size={18} />
              </button>
            </div>
          </div>
        ) : (
          <div className={styles.guestActions}>
            <button
              type="button"
              className={`${styles.actionButton} ${styles.primaryAction}`}
              onClick={guard("send_message", handleSendMesssage, () => fireAnalytics("send_message_from_profile", { action: "open_send_message_modal", send_message_from_profile_user_receiver: data.id, send_message_from_profile_user_sender: userData.id }))}
            >
              <MessageCircle size={16} />
              <span>Enviar mensaje</span>
            </button>
            <button
              type="button"
              className={`${styles.actionButton} ${styles.secondaryAction}`}
              onClick={() => openCalificationModal(data)}
            >
              <Star size={16} />
              <span>Calificar</span>
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    userData: state.general.userData,
    profileVisits: state.profile.profileVisits,
  };
};

export default connect(mapStateToProps, {
  setFile,
  openMainModal,
  closeMainModal,
  setPreviousLocation,
  sendContactNotification,
  openCalificationModal,
  getVisits,
  openSendContactNotificationModal
})(UserInfo);
